import FlickityFade from 'flickity-fade';

import {register} from '../vendor/theme-scripts/theme-sections';
import parallaxImage from '../features/image-parallax';
import scrollButton from '../features/scroll-button';

const sections = [];
const selectors = {
  wrapper: '[data-slideshow-wrapper]',
  speed: 'data-slideshow-speed',
  autoplay: 'data-slideshow-autoplay',
  slideCount: 'data-slideshow-slides',
  prevButton: '[data-slide-custom-prev]',
  nextButton: '[data-slide-custom-next]',
  slideshoIndex: 'data-slideshow-index',
};

const classes = {
  isEnable: 'flickity-enabled',
};

class Slideshow {
  constructor(section) {
    this.container = section.container;
    this.wrapper = section.container.querySelector(selectors.wrapper);
    this.speed = this.wrapper.getAttribute(selectors.speed);
    this.autoplay = this.wrapper.getAttribute(selectors.autoplay) === 'true';
    this.slideCount = parseInt(this.wrapper.getAttribute(selectors.slideCount), 10);
    this.prevButtons = this.wrapper.querySelectorAll(selectors.prevButton);
    this.nextButtons = this.wrapper.querySelectorAll(selectors.nextButton);
    this.flkty = null;
    this.scrollEvent = () => this.scrollEvents();
    this.init();
  }

  init() {
    const settings = {
      autoPlay: this.autoplay && this.speed ? parseInt(this.speed) : false,
      contain: false,
      pageDots: true,
      adaptiveHeight: true,
      accessibility: true,
      wrapAround: this.slideCount !== 2,
      prevNextButtons: false,
      draggable: true,
      fade: true,
      rightToLeft: window.isRTL,
    };
    this.flkty = new FlickityFade(this.wrapper, settings);

    if (this.prevButtons.length) {
      this.prevButtons.forEach((e) => {
        e.onclick = () => {
          this.flkty.previous(true, false);
        };
      });
    }
    if (this.nextButtons.length) {
      this.nextButtons.forEach((e) => {
        e.onclick = () => {
          this.flkty.next(true, false);
        };
      });
    }

    document.addEventListener('theme:scroll', this.scrollEvent);
  }

  scrollEvents() {
    if (this.flkty && this.autoplay && this.speed) {
      const slideshow = this.flkty.element;
      const slideshowBottomPosition = slideshow.getBoundingClientRect().top + window.scrollY + slideshow.offsetHeight;
      if (window.pageYOffset > slideshowBottomPosition) {
        if (this.flkty.player.state === 'playing') {
          this.flkty.pausePlayer();
        }
      } else if (this.flkty.player.state === 'paused') {
        this.flkty.playPlayer();
      }
    }
  }

  unload() {
    document.removeEventListener('theme:scroll', this.scrollEvent);
    if (this.flkty && this.wrapper && this.wrapper.classList.contains(classes.isEnable)) {
      this.flkty.destroy();
    }
  }

  onBlockSelect(evt) {
    const indexEl = evt.target.closest(`[${selectors.slideshoIndex}]`);
    const slideIndex = indexEl.getAttribute(selectors.slideshoIndex);
    const select = parseInt(slideIndex);
    this.flkty.selectCell(select);
    this.flkty.stopPlayer();
  }

  onBlockDeselect() {
    if (this.autoplay) {
      this.flkty.playPlayer();
    }
  }
}

const slideshowSection = {
  onLoad() {
    sections[this.id] = new Slideshow(this);
  },
  onUnload() {
    if (typeof sections[this.id].unload === 'function') {
      sections[this.id].unload();
    }
  },
  onBlockSelect(evt) {
    if (typeof sections[this.id].onBlockSelect === 'function') {
      sections[this.id].onBlockSelect(evt);
    }
  },
  onBlockDeselect(evt) {
    if (typeof sections[this.id].onBlockSelect === 'function') {
      sections[this.id].onBlockDeselect(evt);
    }
  },
};

register('slideshow', [slideshowSection, parallaxImage, scrollButton]);
